import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import moment from 'moment';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormCalendarCardSelect extends Component {
  getMessage(availability) {
    if (availability === 0) {
      return 'Sin disponibilidad';
    } else if (availability < 0.25) {
      return 'Muy baja disponibilidad';
    } else if (availability < 0.5) {
      return 'Baja disponibilidad';
    } else if (availability < 0.75) {
      return 'Disponibilidad normal';
    }

    return 'Alta disponibilidad';
  }

  getDayName(date) {
    return moment(date).format('dddd');
  }

  getDayNumber(date) {
    return moment(date).date();
  }

  handleOnClick() {
    const {
      fieldValue,
      input: { value, onChange },
    } = this.props;

    const newValue = fieldValue === value ? null : fieldValue;

    onChange(newValue);
  }

  render() {
    const {
      date,
      big,
      style,
      availability,
      fieldValue,
      input: { value },
    } = this.props;

    const dayName = this.getDayName(date);
    const dayNumber = this.getDayNumber(date);

    const availabilityMessage = this.getMessage(availability);

    const active = value === fieldValue;

    let className = cx({
      formCalendarCardSelect: true,
      active: active,
      big: big,
      [`${style}`]: true,
    });

    return (
      <div className={classnames(className)} onClick={this.handleOnClick.bind(this)}>
        <div className="container">
          <div>
            <div className="dayName">{dayName}</div>
            <div className="dayNumber">{dayNumber}</div>
          </div>
          <div className="dayAvailability">
            {availability < 0.5 && <div className="lowAvailability">{availabilityMessage}</div>}
            {availability >= 0.5 && availability < 0.75 && (
              <div className="mediumAvailability">{availabilityMessage}</div>
            )}
            {availability >= 0.75 && <div className="highAvailability">{availabilityMessage}</div>}
          </div>
        </div>
      </div>
    );
  }
}
